<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0"
  >
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-gray-800 text-xl font-bold">Add Account</h6>
        <button @click="$emit('closeAddAccount')" class="text-red-500 background-transparent font-bold uppercase px-3 py-1 text-xs outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
      <form @submit.prevent="addAccount">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
          Input Account Airline
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full px-4">
            <div class="relative w-full mb-3">
              <label
                class="block uppercase text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-password"
              >
                Username
              </label>
              <input
                type="text"
                class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                v-model="account.username"
              />
            </div>
          </div>
          <div class="w-full px-4">
            <div class="relative w-full mb-3">
              <label
                class="block uppercase text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-password"
              >
                Password
              </label>
              <input
                type="password"
                class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                v-model="account.password"
              />
            </div>
          </div>
          <div class="w-full px-4">
            <div class="relative w-full mb-3">
              <label
                class="block uppercase text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-password"
              >
                Airline Vendor
              </label>
              <select v-model="vendorId" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
                  <option v-for="vendor in vendors" :key="vendor.id" :value="vendor.id">
                      {{ vendor.label }}
                  </option>
              </select>
            </div>
          </div>
          <!-- <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label
                class="block uppercase text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-password"
              >
                Last Name
              </label>
              <input
                type="text"
                class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                value="Jesse"
              />
            </div>
          </div> -->
          <div class="w-full px-4 mt-3">
            <button
                class="bg-green-500 text-white active:bg-gray-700 text-sm font-bold uppercase py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                type="submit"
            >
                Add
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import VendorService from '../../services/vendor.service'
import AirlineService from '../../services/airline.service'

export default {
    data() {
        return {
            account: {
                username: '',
                password: '',
            },
            vendorId: '',
            vendors: [],
        }
    },

    async mounted() {
      await VendorService.getVendors()
        .then(vendors => {
            this.vendors = vendors
        })
    },

    methods: {
        addAccount() {
            const credentials = this.account
            const vendorId = this.vendorId

            AirlineService.addAccount({credentials, vendorId})
            this.$emit('finishAddAccount')
        }
    }
}
</script>
